// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@turnerBlueprint/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { listStyles } from "@turnerBlueprint/Overrides/Widgets/MyLists/MyListsList";
import { color, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

listStyles.messageText = {
    ...dataTableStyles.noResultsText,
};

listStyles.notifyWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 0,
        offsetCss: css`
            justify-content: space-between;
        `,
        css: css`
            ${xScreen("lte", "md")} {
                border-bottom: 1px solid ${color("common.border")};
            }

            ${({ isOdd }: any) =>
                isOdd &&
                css`
                    ${xScreen("lte", "md")} {
                        .card_container__wrapper:nth-last-of-type(2) {
                            border-bottom: 1px solid ${color("common.border")};
                        }
                    }
                `}
        `,
    },
};

listStyles.cardContainer = {
    cardDivider: {
        css: css`
            padding-bottom: 16px;
            margin: 0 0 16px 0;
            width: 100%;

            ${xScreen("lte", "md")} {
                width: calc(50% - 20px);

                &:nth-last-of-type(-n + 2) {
                    border-bottom: none;
                }
            }

            ${xScreen("lt", "sm")} {
                width: 100%;
                &,
                &:nth-last-of-type(-n + 2) {
                    border-bottom: 1px solid ${color("common.border")};
                }
                &:last-of-type {
                    border-bottom: none;
                }
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 0px;
        `,
    },
};
